module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEV1qtsAAAD///+roOWzAAAAKUlEQVRIx2MYBaNgFAxlsAoHWEFlmVAcIGRUZpDL0CuFjIJRMAqGMAAA1M4R3IrQtOYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Botswana.png
// module id = 563
// module chunks = 0